/*! V11.1 Ultra Performance (Home + Product) */
(function () {
  function isProductTemplate() {
    var cls = (document.body && document.body.className) ? document.body.className : '';
    var htmlCls = document.documentElement.className || '';
    return (cls.indexOf('template-product') !== -1) || (htmlCls.indexOf('template-product') !== -1);
  }

  function markLazySections() {
    var main = document.querySelector('main');
    if (!main) return;
    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    if (!sections.length) return;

    // Keep the first N sections "eager". Everything else becomes lazy-rendered.
    // Home: keep 2 (hero + next section). Product: keep 2 (gallery/buybox + next).
    var keep = isProductTemplate() ? 2 : 2;

    for (var i = 0; i < sections.length; i++) {
      if (i >= keep) sections[i].classList.add('v11-lazy-section');
    }
  }

  function setupSectionObserver() {
    if (!('IntersectionObserver' in window)) return;
    var nodes = document.querySelectorAll('.v11-lazy-section');
    if (!nodes.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('v11-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '350px' });

    Array.prototype.forEach.call(nodes, function (el) { io.observe(el); });
  }

  function autoLazyImages() {
    // Add loading="lazy" to images clearly below the first viewport, without touching LCP images.
    var imgs = document.images;
    if (!imgs || !imgs.length) return;

    var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.hasAttribute('loading')) continue;

      // Skip likely LCP candidates
      if (img.closest('.header, header, .hero, .banner, .product__media, .product-media, .main-product')) continue;

      try {
        var rect = img.getBoundingClientRect();
        if (rect.top > vh * 1.2) img.setAttribute('loading', 'lazy');
      } catch (e) {}
    }
  }

  function deferNonCriticalStyles() {
    // Optional: convert preload styles with data-v11-onload to non-blocking
    var links = document.querySelectorAll('link[data-v11-onload][rel="preload"][as="style"]');
    Array.prototype.forEach.call(links, function (l) {
      l.addEventListener('load', function () {
        l.rel = 'stylesheet';
      });
    });
  }

  function onReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  onReady(function () {
    markLazySections();
    autoLazyImages();
    setupSectionObserver();
    deferNonCriticalStyles();
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
  });
})();
